var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"width":"22px","height":"22px"},attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('title',[_vm._v("send")]),_c('path',{attrs:{"fill":"currentColor","d":"M2,21L23,12L2,3V10L17,12L2,14V21Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }